/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { AgentMemoryControllerFindAllQueryResponse, AgentMemoryControllerFindAllQueryParams, AgentMemoryControllerFindAll401, AgentMemoryControllerFindAll403 } from "../../models/agentMemoriesController/AgentMemoryControllerFindAll";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { agentMemoryControllerFindAll } from "../../clients/agent-memoriesService/agentMemoryControllerFindAll";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const agentMemoryControllerFindAllQueryKey = (params: AgentMemoryControllerFindAllQueryParams = {}) => [{
  url: '/api/v1/agent-memories'
}, ...(params ? [params] : [])] as const;
export type AgentMemoryControllerFindAllQueryKey = ReturnType<typeof agentMemoryControllerFindAllQueryKey>;
export function agentMemoryControllerFindAllQueryOptions(params?: AgentMemoryControllerFindAllQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = agentMemoryControllerFindAllQueryKey(params);
  return queryOptions<AgentMemoryControllerFindAllQueryResponse, ResponseErrorConfig<AgentMemoryControllerFindAll401 | AgentMemoryControllerFindAll403>, AgentMemoryControllerFindAllQueryResponse, typeof queryKey>({
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return agentMemoryControllerFindAll(params, config);
    }
  });
}

/**
 * @summary List accessible AI agent memory profiles
 * {@link /api/v1/agent-memories}
 */
export function useAgentMemoryControllerFindAll<TData = AgentMemoryControllerFindAllQueryResponse, TQueryData = AgentMemoryControllerFindAllQueryResponse, TQueryKey extends QueryKey = AgentMemoryControllerFindAllQueryKey>(params?: AgentMemoryControllerFindAllQueryParams, options: {
  query?: Partial<QueryObserverOptions<AgentMemoryControllerFindAllQueryResponse, ResponseErrorConfig<AgentMemoryControllerFindAll401 | AgentMemoryControllerFindAll403>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? agentMemoryControllerFindAllQueryKey(params);
  const query = useQuery({
    ...agentMemoryControllerFindAllQueryOptions(params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AgentMemoryControllerFindAll401 | AgentMemoryControllerFindAll403>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}